import { Component, OnInit, Input } from '@angular/core';
import { Label, MultiDataSet, Colors } from 'ng2-charts';
import { ChartType } from 'chart.js';
import { min } from 'rxjs/operators';

@Component({
  selector: 'app-property-rental-income-expense',
  templateUrl: './property-rental-income-expense.component.html',
  styleUrls: ['./property-rental-income-expense.component.scss']
})
export class PropertyRentalIncomeExpenseComponent implements OnInit {

  constructor() { }
  @Input() public income;
  @Input() public serviceCharge;
  @Input() public repairsAndMaintenance;
  @Input() public legalAndOtherProffessionalServices;
  @Input() public managingAgentCharge;
  @Input() public insurance;
  @Input() public primaryMortgageRepayments;
  @Input() public nonPrimaryMortgageRepayments;
  @Input() public utilitiesCharge;
  // barChartLabels: Label[] = [];
  // barChartData;
  // barChartLabelColors: Colors;
  // barChartType: ChartType = 'bar';
  // barChartlabels;
  public showCanvas = false;
  public incomeHeight = "";
  public serviceHeight = "";
  public repairsHeight = "";
  public legalHeight = "";
  public repaymentsHeight = "";
  public agentHeight = "";
  public insuranceHeight = "";
  public utilitiesHeight = "";
  public expenses: {}[] = [];
  public barHeight = 300; //px
  public barHeightText = this.barHeight + "px";
  public dummy = "10%";
  public expenseTotal = 0;
  public netIncome = 0;
  public netIncomeHeight = "";
  
  ngOnInit() {
    this.showCanvas = false;
    if (!this.insurance) { this.insurance = 0; }
    let totalIncome = 0;
    if (!this.income) { this.income = 0; }
    if (!this.serviceCharge) { this.serviceCharge = 0; }
    if (!this.repairsAndMaintenance) { this.repairsAndMaintenance = 0; }
    if (!this.legalAndOtherProffessionalServices) { this.legalAndOtherProffessionalServices = 0; }
    if (!this.primaryMortgageRepayments) { this.primaryMortgageRepayments = 0; }
    if (!this.nonPrimaryMortgageRepayments) { this.nonPrimaryMortgageRepayments = 0; }
    if (!this.managingAgentCharge) { this.managingAgentCharge = 0; }
    if (!this.insurance) { this.insurance = 0; }
    if (!this.utilitiesCharge) { this.utilitiesCharge = 0; }
    this.expenseTotal = Number(this.serviceCharge) +
      Number(this.repairsAndMaintenance) +
      Number(this.legalAndOtherProffessionalServices) +
      Number(this.primaryMortgageRepayments) +
      Number(this.nonPrimaryMortgageRepayments) +
      Number(this.managingAgentCharge) +
      Number(this.insurance) +
      Number(this.utilitiesCharge);
    this.netIncome = this.income - this.expenseTotal;
    let totalMaxSum = Math.max(this.income, this.expenseTotal);
    let minPixels = 9;

    //if (this.income > 0) { this.incomeHeight = Math.round(this.income / totalMaxSum * 100) + "%"; }
    if (this.income > 0) {
      let height = Math.round(this.barHeight * this.income / totalMaxSum);
      this.incomeHeight = height + "px";
    }

    if (this.netIncome > 0) {
      let height = Math.round(this.barHeight * this.netIncome / totalMaxSum);
      this.netIncomeHeight = height + "px";
    }

    if (this.serviceCharge > 0) {
      let height = Math.round(this.barHeight * this.serviceCharge / totalMaxSum);
      if (height < minPixels) {
        //this.serviceCharge = 0;
        this.expenses.push({ name: "service", amount: this.serviceCharge, height: "3px", color: "" })
      }
      else {
        this.expenses.push({ name: "service", amount: this.serviceCharge, height: height + "px", color: "" })
      }
    }
    if (this.repairsAndMaintenance > 0) {
      let height = Math.round(this.barHeight * this.repairsAndMaintenance / totalMaxSum);
      if (height < minPixels) {
        this.expenses.push({ name: "repairs", amount: this.repairsAndMaintenance, height: "3px", color: "" });
      }
      else {
        this.expenses.push({ name: "repairs", amount: this.repairsAndMaintenance, height: height + "px", color: "" });
      }
    }
    if (this.legalAndOtherProffessionalServices > 0) {
      let height = Math.round(this.barHeight * this.legalAndOtherProffessionalServices / totalMaxSum);
      if (height < minPixels) {
        this.expenses.push({ name: "legal", id: "legalAndOtherProffessionalServices", amount: this.legalAndOtherProffessionalServices, height: "3px", color: "" });
      }
      else {
        this.expenses.push({ name: "legal", id: "legalAndOtherProffessionalServices", amount: this.legalAndOtherProffessionalServices, height: height + "px", color: "" });
      }
    }
    if (this.primaryMortgageRepayments > 0) {
      let height = Math.round(this.barHeight * this.primaryMortgageRepayments / totalMaxSum);
      if (height < minPixels) {
        this.expenses.push({ name: "mortgage", amount: this.primaryMortgageRepayments, height: "3px", color: "" });
      }
      else {
        this.expenses.push({ name: "mortgage", amount: this.primaryMortgageRepayments, height: height + "px", color: "" });
      }
    }
    if (this.nonPrimaryMortgageRepayments > 0) {
      let height = Math.round(this.barHeight * this.nonPrimaryMortgageRepayments / totalMaxSum);
      if (height < minPixels) {
        this.expenses.push({ name: "mortgage", amount: this.nonPrimaryMortgageRepayments, height: "3px", color: "" });
      }
      else {
        this.expenses.push({ name: "mortgage", amount: this.nonPrimaryMortgageRepayments, height: height + "px", color: "" });
      }
    }
    if (this.managingAgentCharge > 0) {
      let height = Math.round(this.barHeight * this.managingAgentCharge / totalMaxSum);
      if (height < minPixels) {
        this.expenses.push({ name: "agent", amount: this.managingAgentCharge, height: "3px", color: "" })
      }
      else {
        this.expenses.push({ name: "agent", amount: this.managingAgentCharge, height: height + "px", color: "" })
      }
    }
    if (this.insurance > 0) {
      let height = Math.round(this.barHeight * this.insurance / totalMaxSum);
      if (height < minPixels) {
        this.expenses.push({ name: "insurance", amount: this.insurance, height: "3px", color: "" });
      }
      else {
        this.expenses.push({ name: "insurance", amount: this.insurance, height: height + "px", color: "" });
      }
    }
    if (this.utilitiesCharge > 0) {
      let height = Math.round(this.barHeight * this.utilitiesCharge / totalMaxSum);
      if (height < minPixels) {
        this.expenses.push({ name: "utilites", amount: this.utilitiesCharge, height: "3px", color: "" });
      }
      else {
        this.expenses.push({ name: "utilites", amount: this.utilitiesCharge, height: height + "px", color: "" });
      }
    }
    this.expenses.sort((a, b) => b["amount"] - a["amount"]);
    //let colors = ["#34274D;","#471A66;","#5C4A7E;","#BCB7C8;","#34274D;","#471A66;","#5C4A7E;"];
    for (let i = 0; i < this.expenses.length; i++) {
      //this.expenses[i]["color"] = colors[i];
      this.expenses[i]["id"] = "color" + [i + 1];
    }
    this.showCanvas = true;
    //for stacking:https://stackoverflow.com/questions/56006074/how-to-change-nan-values-to-0-in-chart-js
  }

}
